import React from 'react'
import ReactDOM from 'react-dom'
import { Route, HashRouter } from 'react-router-dom'
import { SceneContextProvider } from './SceneContext'
import App from './App'
import './css/index.css'

ReactDOM.render(
  <HashRouter>
      <Route path="/*">
        <SceneContextProvider>
          <App />
        </SceneContextProvider>
      </Route>
  </HashRouter>,
  document.getElementById('root')
);


//import reportWebVitals from './reportWebVitals';
//reportWebVitals();
